import { render, staticRenderFns } from "./HomeSkeleton.vue?vue&type=template&id=575214e5&"
import script from "./HomeSkeleton.vue?vue&type=script&lang=js&"
export * from "./HomeSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./HomeSkeleton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports